import React, {Fragment} from 'react';
import { Helmet } from 'react-helmet';
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import CTA from "../../components/CTA";
import PricingPlan from '../../components/PricingPlan';


import './style.scss';
import { Typography } from '@material-ui/core';


const styles = {
    FaqStyle: {
        margin:23,
    },
}    

const Pricing =() => {
    return(
        <Fragment>
            <Helmet>
                <title>One Two Pay Pricing</title>
                <meta name="description" content="Todos!" />
            </Helmet>
            <BreadCrumb
                pagename="Pricing"
                title="We have the best Pricing, the best, the absoulte best"
            />
          
            <PricingPlan style={styles.FaqStyle} />

            <Typography>
                Here is an area for you to write some words, possibly a hakui 
            </Typography>

            
            <CTA/>
            <Footer/>
        </Fragment>
    )
};
export default Pricing;